/* import __COLOCATED_TEMPLATE__ from './topic-definition-keyphrases-tooltip.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();